<template>
    <div class="container">
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220711/1657526024572.png">
        </div>
        <div class="ceiling-view" v-if="ceilingType" :class="{'ceiling-fixed':ceilingType}">
            <div class="ceiling-tab">
                <div class="tab-item"
                    v-for="(item, index) in tabList" :key="index"
                    :class="{'active-tab': activeTab === index}"
                    @click="changeTab(item,index)"
                >
                    <span>{{item.stage}}</span>
                    <div v-if="activeTab === index" class="bor" />
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220711/1657526041127.png">
        </div>
        <div class="section" id="section_1">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220711/1657526057424.png">
        </div>
        <div class="section-main">
            <!-- <img class="main-title" :src="imgObj.title"> -->
            <div class="_tb">
                <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane class="main-tab" v-for="(item, index) in (stageList || [])" :key="index" :label="item.stage" :name="index">
                        <div class="region">
                            <div class="m-title"><div class="tx">{{item.title}}</div><div class="btn" @click="seeDetail(item)"></div></div>
                            <div class="m-icon"></div>
                            <div class="m-txt">
                                <div class="m-left">
                                    <div class="l-title">学习目标</div>
                                    <div class="bor"></div>
                                    <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" >{{v}}</div>
                                </div>
                                <div class="m-right">
                                    <div class="l-title">关键技术点</div>
                                    <div class="bor"></div>
                                    <div class="item" v-for="(v, i) in item.skillsList" :key="i" >{{v}}</div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
                <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                <button class="jump-btn" @click="JumpFn('领取完整课程安排')">
                    <img src="https://s20.lgstatic.com/growth/activity/20220711/1657530286131.png">
                </button>
            </div>
        </div>
        <div class="section" id="section_2">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657606270150.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220711/1657526503367.png">
            <div class="section-btn" @click="JumpFn('获取更多项目资料')"></div>
        </div>
        <div class="section" id="section_3">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20221118/1668753052847.jpg">
        </div>
        <!-- <div class="section" id="section_4">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220711/1657526538598.png">
        </div> -->
        <!-- <div class="section-sw" id="section_5">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220711/1657529503750.png">
            <div class="swiper-container sw1-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperListNew" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination sw1-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657606308474.png">
        </div> -->
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20221118/1668753087183.jpg">
        </div>
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
          <div class="box box-fixed">
            <div class="box-inner">
              <div class="box10-content">
                <div class="box10-left">
                  <img src="https://s21.lgstatic.com/growth/activity/20220610/1654846808855.png" alt="">
                  咨询课程顾问 抢大额优惠券
                </div>
                <div class="box10-right" @click="JumpFn('名额有限立即抢占')">好课速享 马上抢占</div>
              </div>
            </div>
          </div>
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './data.js'
import activity from '../../../common/activity';
export default {
    name: 'SignIn',
    data() {
        return {
            activity,
            List,
            imgObj:{},
            imgList:[],
            imgList1:[],
            tabList:[],
            stageList:[],
            swiperList:[],
            swiperList1:[],
            ceilingType:false,//吸顶tab
            activeTab:0,
            showData:{},
            showModal:false,
            swiperListNew: [
                "https://s20.lgstatic.com/growth/activity/20220711/1657529691198.png",
                "https://s20.lgstatic.com/growth/activity/20220711/1657529701428.png",
                "https://s21.lgstatic.com/growth/activity/20220711/1657529709996.png",
                "https://s21.lgstatic.com/growth/activity/20220711/1657529718286.png"
            ],
            addressIdsMap: {
                "课程体系": "x1tz4",
                "实战项目": "y1tz5",
                "就业服务": "z1tz6",
                "用户评价": "a1tz7",
                "领取完整课程安排": "b1tz8",
                "获取更多项目资料": "c1tz9",
                "名额有限立即抢占": "d1tza"
            }
        };
    },
    mounted() {
        let dataList = this.List.data;
        this.imgObj = dataList.pc.imgObj
        this.imgList = dataList.pc.imgList
        this.imgList1 = dataList.pc.imgList1
        this.swiperList = dataList.pc.swiperList
        this.swiperList1 = dataList.pc.swiperList1

        this.tabList = dataList.tabList
        this.stageList = dataList.stageList

        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1pu4'});
            this.platTrack('pcpv', {
                page_id: 'n1tyu',
            })
            this.swiperInit()
        },500)
        window.addEventListener('scroll', this.scrollTopFn)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        changeTab(item,index) {
            this.activeTab = index
            let arr = [
                "#section_1",
                "#section_2",
                "#section_3",
                // "#section_4",
                // "#section_5"
            ]
            this.$el.querySelector(arr[index]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1pu4',
            //     'button_name': item.stage
            // });
            this.platTrackClickFn(item.stage);
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 540 ? true : false; //吸顶tab
            let arr = [
                "section_1",
                "section_2",
                "section_3",
                // "section_4",
                // "section_5"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 200) {
                    this.activeTab = index
                }
            })
        },
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1pu4',
            //     'button_name': '立即免费领取'
            // });
            str && this.platTrackClickFn(str);
            setTimeout(() => {
              window.location.href = 'https://t.lagou.com/DR7DR0Rcs=947';
            }, 200)
        },
        seeDetail(val) {
            this.showModal = true;
            this.showData = val
        },
        close() {
            this.showModal = false;
        },
        changeTabs(val) {
            this.showModal = false
        },
        swiperInit() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.sw1-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.sw1-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 500 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'n1tyu',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    min-width: 1200PX;
    background: #F4F4F4;
    padding-bottom: 160PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .section-btn {
            position: absolute;
            bottom: 20PX;
            left: 50%;
            transform: translateX(-50%);
            width: 600PX;
            height: 88PX;
        }
        .btn1 {
            position: absolute;
            background-color:transparent;
            border: none;
            bottom: 40PX;
            left: 50%;
            transform: translate(-50%);
            width: 1200PX;
            height: 120PX;
            z-index: 9;
        }
        .btn-img-1 {
            position: absolute;
            background-color:transparent;
            border: none;
            bottom: 40PX;
            left: 50%;
            transform: translate(-50%);
            width: 440PX;
            img {
                width: 100%;
                display: block;
            }
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 1000PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }
    .ceiling-view {
        width: 100%;
        height: 66PX;
        margin: 0PX auto 40PX;
        background-color: #fff;
        .ceiling-tab {
            width: 1100PX;
            margin: 0 auto;
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;
            // transform: scale(.7);
            .tab-item {
                position: relative;
                flex: 1;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 168PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(151deg, #FF5325 0%, #EB0505 100%);
                }
            }
            .active-tab {
                box-sizing: border-box;
                padding-left: 40PX;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s20.lgstatic.com/growth/activity/20210917/1631862872853.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        @media screen and (max-width:1900px){
            .ceiling-tab {
                width: 940PX;
                .tab-item {
                    .bor {
                        width: 148PX;
                    }
                }
                .active-tab {
                    padding-left: 40PX;
                    &::before{
                        left: 44PX;
                    }
                }
            }
        }
        @media screen and (max-width:1500px){
            .ceiling-tab {
                width: 790PX;
                .tab-item {
                    .bor {
                        width: 140PX;
                    }
                }
                .active-tab {
                    padding-left: 30PX;
                    &::before{
                        left: 26PX;
                    }
                }
            }
        }

    }
    .ceiling-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 30;
    }
    .section-main {
        width: 100%;
        // background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
        box-sizing: border-box;
        min-width: 1200PX;
        margin-bottom: 100PX;
        padding-top: 1PX;
        .main-title {
            display: block;
            margin: 50PX auto 20PX;
            width: 680PX;
        }
        ._tb {
            transform: translateY(50PX);
            position: relative;
            margin: 0PX auto 0PX;
            width: 1000PX;
            background-color: #fff;
            box-sizing: border-box;
            padding-bottom: 100PX;
            border-radius: 22px;
            z-index: 9;
            /deep/ .el-tabs {
                width: 100%;
                .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                    height: 96PX;
                    line-height: 96PX;
                    color: #fff;
                    border-radius: 16PX 16PX 0 0;
                }
                .el-tabs__nav-wrap {
                    background-image: linear-gradient(-30deg, #F56611 0%, #FFAA53 100%);
                }
                .el-tabs__item {
                    line-height: 47PX;
                    text-align: center;
                    width: 130PX;
                    height: 47PX;
                    padding: 0;
                    font-size: 18PX;
                    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                    font-weight: 400;
                    color: #fff;
                    margin: 0 6PX;
                }
                .el-tabs__nav-wrap::after{
                    background-color: transparent;
                }
                .el-tabs__active-bar {
                    background-color: transparent;
                }
                .el-tabs__item.is-active {
                    border-radius: 50PX;
                    padding: 0;
                    background: linear-gradient(327deg, #E33917 0%, #FF7500 100%);
                    color: #fff;
                }
                .el-tabs__nav-prev {
                    top: 50%;
                    font-weight: 500;
                    font-size: 34PX;
                    transform: translateY(-50%);
                    left: -5PX;
                }
                .el-tabs__nav-next {
                    top: 50%;
                    font-weight: 500;
                    font-size: 34PX;
                    transform: translateY(-50%);
                    right: -5PX;
                }
            }
            .region {
                width: 100%;
                padding-top: 20PX;
                .m-title {
                    width: 100%;
                    height: 30PX;
                    position: relative;
                    font-size: 24PX;
                    color: #303032;
                    text-align: center;
                    font-family: Helvetica;
                    font-weight: normal;
                    .tx {
                        position: absolute;
                        top: 0PX;
                        left: 50%;
                        transform: translate(-50%);
                    }
                    .btn {
                        float: right;
                        width: 90PX;
                        height: 30PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40PX;
                    }
                }
                .m-icon {
                    margin: 8PX auto;
                    width: 688PX;
                    height: 2PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                    background-size: 100% 100%;
                }
                .m-txt {
                    width: 100%;
                    display: flex;
                    margin-top: 30PX;
                    .m-left {
                        flex: 1;
                        box-sizing: border-box;
                        padding: 10PX 30PX;
                    }
                    .m-right {
                        width: 312PX;
                        box-sizing: border-box;
                        padding: 10PX 10PX;
                    }
                    .l-title {
                        font-size: 16PX;
                        font-family: Helvetica;
                        color: #36363C;
                    }
                    .bor {
                        width: 312PX;
                        height: 1PX;
                        margin: 16PX 0 20PX;
                        background-color: rgba(132, 132, 135, .4);
                    }
                    .item {
                        position: relative;
                        font-size: 14PX;
                        font-family: Helvetica;
                        color: #49494B;
                        padding-left: 15PX;
                        margin: 14PX 0;
                        &::after {
                            position: absolute;
                            content: '';
                            left: 0PX;
                            top: 8PX;
                            width: 4PX;
                            height: 4PX;
                            border-radius: 50%;
                            background: #6469A7;
                        }
                    }
                }
            }
        }
        .modal {
            position: absolute;
            top: 152PX;
            left: 50%;
            transform: translate(-50%);
            width: 1100PX;
            border-radius: 16PX;
            background-color: #fefefe;
            z-index: 999;
            border: 2PX solid #6469A7;
            box-sizing: border-box;
            padding: 20PX 50PX 40PX;
            .close {
                position: absolute;
                right: 14PX;
                top: 14PX;
                width: 40PX;
                height: 40PX;
            }
            .modal-title {
                font-size: 20PX;
                padding:35PX 0 10PX;
                color: #6469A7;
            }
            .modal-desc {
                font-size: 18PX;
                color: #6469A7;
                padding-left: 18PX;
            }
        }
        .jump-btn {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: -24PX;
            width: 408PX;
            height: 68PX;
            background-color:transparent;
            border: none;
            img {
                width: 100%;
                display: block;
            }
        }
        .tips-tab {
            font-size: 14PX;
            color: #666;
            position: absolute;
            bottom: 80PX;
            right: 60PX;
        }

    }
    .sw-section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        margin-top: 50PX;
        .sw-btn {
            width: 408PX;
            height: 68PX;
            background-color:transparent;
            border: none;
            display: block;
            margin: 50PX auto;
            img {
                width: 100%;
                display: block;
            }
        }
        /deep/ .current-wrap {
            width: 1040PX;
            height: 600PX;
            .swiper-slide {
                width: 860PX;
                img {
                    display: block;
                    width: 860PX;
                    margin: 0 auto;
                }
                // &.swiper-slide-active {
                //     opacity: 1;
                // }
                // &.swiper-slide-next, &.swiper-slide-prev {
                //     opacity: .5;
                // }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
                border-radius: 50%;
                opacity: .3;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
                    opacity: 1;
                }
            }
            .swiper-button-prev {
                background: url('https://s20.lgstatic.com/growth/activity/20210727/1627374061466.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
            }
            .swiper-button-next {
                background: url('https://s21.lgstatic.com/growth/activity/20210727/1627374039722.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
            }
        }
    }
    .sw-section1 {
        /deep/ .wrap {
            width: 860PX;
            height: 420PX;
            margin: 30PX auto;
            .swiper-slide {
                width: 860PX;
                img {
                    width: 100%;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
                border-radius: 50%;
                opacity: .4;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
                    opacity: 1;
                }
            }
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: 0PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        min-width: 1200PX;
        box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
        .box {
          width: 100%;
          .box-inner {
            position: relative;
            width: 1200PX;
            height: 100%;
            margin: 0 auto;
            overflow: hidden;
          }
          &-fixed {
            position: fixed;
            bottom: 0;
            left: 0;
            height: 118PX;
            line-height: 118PX;
            background-color: #fff;
            z-index: 999;
          }
        }
        .box10-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .box10-left {
            display: flex;
            align-items: center;
            color: #fe6622;
            font-size: 26PX;
            & > img {
              width: 24PX;
              height: 24PX;
              margin-right: 12PX;
            }
          }
          .box10-right {
            width: 384PX;
            height: 68PX;
            line-height: 68PX;
            background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
            border-radius: 39PX;
            font-size: 24PX;
            color: #fff;
            text-align: center;
          }
        }
        .img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
    }
}
.section-sw {
    position: relative;
    width: 100%;
    height: 805PX;
    background-image: linear-gradient(181deg, #FFB317 0%, #FF613A 100%);
    .img {
        position: absolute;
        top: 67PX;
        left: 50%;
        width: 984PX;
        transform: translateX(-50%);
    }
    /deep/ .sw1-wrap {
        position: absolute;
        top: 310PX;
        left: 50%;
        transform: translateX(-50%);
        width: 1200PX;
        height: 390PX;
        margin-top: 60PX;
        .swiper-slide {
            width: 782PX;
            height: 352PX;
            opacity: 0;
            img {
                display: block;
                width: 782PX;
                margin: 0 auto;
            }
            &.swiper-slide-active {
                opacity: 1;
            }
            &.swiper-slide-next, &.swiper-slide-prev {
                opacity: .5;
            }
        }
        .swiper-pagination {
            bottom: 0PX;
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background: linear-gradient(90deg, #fff 0%, #fff 100%);
            border-radius: 50%;
            opacity: .5;
            &-active{
                opacity: 1;
                border-radius: 10PX;
                width: 22PX;
                background: linear-gradient(90deg, #fff 0%, #fff 100%);
            }
        }
        .swiper-button-prev {
            background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
            background-size: 100% 100%;
            width: 58PX;
            height: 58PX;
            // top: 50%;
            // transform: translateY(-50%);
            // left: 0PX;
        }
        .swiper-button-next {
            background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
            background-size: 100% 100%;
            width: 58PX;
            height: 58PX;
            // // right: -80PX;
            // // top: 50%;
            // transform: translateY(-50%);
            // right: 0PX;
        }
    }
}
</style>
